import React from "react";
import InfoIcon from "@mui/icons-material/Info";

const SubscriptionPricingLink = () => (
  <div className="flex cursor-pointer gap-1 font-semibold text-slate-700 hover:underline">
    <InfoIcon className="my-auto" fontSize="inherit" />
    <a
      href="/pricing.php"
      target="_blank"
      className="my-auto text-sm text-inherit"
    >
      Pricing
    </a>
  </div>
);

export default SubscriptionPricingLink;
